import React, { useState, useEffect } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import ChatInput from './ChatInput';
import ConfirmDialog from './ConfirmDialog';
import PhoneNumberModal from './PhoneModal';
import ThankYouModal from './ThankYouModal';
import OfflineScreen from './OfflineScreen';

const ASSISTANT_TYPE_CHATAI = '1';
const ASSISTANT_TYPE_INTERNAL = '2';
const ASSISTANT_TYPE_SALESMAN = '3';
const ASSISTANT_TYPE_NOAI = '4';

const Chat = () => {
  const [colors, setColors] = useState({
    primary: {
      backgroundColor: '#032c52',
      color: '#ffffff',
    },
    secondary: {
      backgroundColor: '#bd0b1f',
      color: '#ffffff',
    },
  });

  // Określa czy jest czas pracy
  const [isWorkTime,setIsWorkTime] = useState(false);

  const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [isChatRunning, setIsChatRunning] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [type, setType] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [threadId, setThreadId] = useState('');
  const [configHash, setConfigHash] = useState('');
  const [sendDisabled, setSendDisabled] = useState(true);
  const [isCaptchaReady, setIsCaptchaReady] = useState(false);
  const [configTexts, setConfigTexts] = useState({
    'greetAiInHours':'',
    'greetAiAfterHours':'',
    'greetAskPhone':'',
    'greetOffline':'',
    'greetAfterPhone':'',
    'greetAfterChat':'',
    'buttonCallMe':'',
    'buttonEnd':'',
    'buttonAskForHuman':'',
    'msgEnterText':'',
    'avatarChat':'',
    'triggerIdForCall':'',
  });

  const defaultAvatar =
    'https://img.icons8.com/?size=36&id=103790&format=png&color=000000';

  useEffect(() => {
    if (isChatRunning) {
      initializeChat();
    }
  }, [isChatRunning]);

   // Ładnowanie captchy
   useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6Ld1mlAqAAAAAIj8RWYd-FwRRRsrQhYaCEFEpk3C';
    script.async = true;
    script.onload = () => {
      setIsCaptchaReady(true);
    };
    document.body.appendChild(script);

  }, []);

  useEffect(() => {
    if (isCaptchaReady) {
      checkRemoteConfig();
    }
  }, [isCaptchaReady]);

  function closeModal(){
    setIsChatRunning(false);
    setIsDialogOpen(false);
    window.parent.postMessage({ type: 'CLOSE_CHAT' }, '*');
  }

  function generateHash(length) {
    const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = ' ';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

  const handlePhoneConfirm = (number) => {
    setIsPhoneModalOpen(false);
    setIsThankYouModalOpen(true);
    addLead(number);
  };

  const scrollToBottom = () => {
    var objDiv = document.getElementById("messagesBox");
    if(objDiv)
      objDiv.scrollTop = objDiv.scrollHeight;
  }

  const initializeChat = async () => {

    const body = new URLSearchParams();
    body.append('configHash',configHash);

    try {
      if(type===ASSISTANT_TYPE_NOAI){
          // Chat z konsultantem
          let hash = generateHash(32);
          setThreadId(hash);
          console.log('hash:',hash);
          body.append('command', 'sendConsultantCheckSignal');
          body.append('conversationHash', hash);
          const response = await fetch('https://automation.bs4server.com/bs4webhook_chat.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
          });
          setIsListening(true);
          //const data = await response.json();
          //console.log(data);
          //setThreadId(data.threadId);
  
          // if(data.messages && data.messages[0]) {
          //   setMessages([{ from: 'ai', body: data.messages[0].body }]);
          //   setSendDisabled(false);
          // }
      }
      else if(type===ASSISTANT_TYPE_CHATAI){

        // Chat AI  
        body.append('command', 'initChat');
      
        const response = await fetch('https://automation.bs4server.com/bs4webhook_chat.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: body.toString(),
        });
        const data = await response.json();
        setThreadId(data.threadId);

        if(data.messages && data.messages[0]) {
          setMessages([{ from: 'ai', body: data.messages[0].body }]);
          setSendDisabled(false);
        }
      } 
    } catch (error) {
      console.error('Error initializing chat:', error);
    }
  };

  const addLead = async (number) => {
    const body = new URLSearchParams();
    body.append('command', 'addLeadFromChat');
    body.append('configHash', configHash);
    body.append('data', JSON.stringify({
      "phone":number
    }));

      const response = await fetch('https://automation.bs4server.com/bs4webhook_chat.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body.toString(),
      });
  }

  const checkRemoteConfig = async () => {
    let params = new URLSearchParams(window.location.search);
    const hash = params.get('configHash');
    //const hash = 'o4W4a0Q4stLoV1YF$suZiVGveSp_on6oJzRC3YgGeRFP1WVbIDCeaJG7NRrCl1lL';
    //const hash = '!$Hue96VYlsHno5$$QO92u6ZIkUDBmggUn_!mMXsVkcT31nLLHASHvfKdTOlE-_D'; // mentor

    // Jeśli nie ma configHash w URL to zakończ
    if(!hash){
      console.error("Param 'configHash' in the URL is missing!");
      return;
    }

    const body = new URLSearchParams();
    body.append('command', 'configCheck');
    body.append('configHash', hash);

    try {
      const response = await fetch('https://automation.bs4server.com/bs4webhook_chat.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body.toString(),
      });

      const data = await response.json();
      let details = JSON.parse(data.configDetails);

      if(details===false){
        console.error(`Config for configHash '${hash}' returned false.`);
        return;
      }

      // Jeśli sprecyzowane są kolory chatu to zastępujemy te defaultowe
      if(details.primary_color!==null)
        setColors(prev => ({...prev,primary:JSON.parse(details.primary_color)}))

      if(details.secondary_color!==null)
        setColors(prev => ({...prev,secondary:JSON.parse(details.secondary_color)}))

      setConfigTexts(details.predefined_texts);
      setConfigHash(hash);
      setType(details.type);
      setIsWorkTime(data.workingHours);

    } catch (error) {
      console.error('Error while fetching configChat:', error);
    }
  };

  const handleChatToggle = async () => {
    if (!isChatRunning) {
      try {
        let score = await startCaptchaValidation();
        if (score > 0.6) {
          setIsChatRunning(true);
        } else {
          throw new Error('Bot detected');
        }
      } catch (error) {
        console.error('Captcha check failed:', error);
      }
    }
  };

  const startCaptchaValidation = async () => {
    if (!isCaptchaReady) {
      console.error('Captcha is not ready yet.');
      return;
    }

    try {
      const token = await window.grecaptcha.enterprise.execute(
        '6Ld1mlAqAAAAAIj8RWYd-FwRRRsrQhYaCEFEpk3C',
        { action: 'LOGIN' }
      );

      const response = await fetch('https://licence.bs4server.com/check_captcha.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event: {
            token,
            siteKey: '6Ld1mlAqAAAAAIj8RWYd-FwRRRsrQhYaCEFEpk3C',
          },
        }),
      });

      const data = await response.json();

      if (data.error !== '') {
        throw new Error(data.error);
      }

      return data.score;

    } catch (error) {
      console.error('Captcha validation failed:', error);
      throw error;
    }
  };

  const sendMessage = async () => {
    setSendDisabled(true);
    if (userInput.trim() === '') return;

    const messageBody = userInput.trim();
    setMessages((prevMessages) => [
      ...prevMessages,
      { from: 'user', body: messageBody },
      { from: 'ai', body: 'Pisze...'}
    ]);
    setUserInput('');
    scrollToBottom();

    const body = new URLSearchParams();
    body.append('command', 'sendMessage');
    body.append('body', messageBody);
    body.append('threadId', threadId);

    try {
      const response = await fetch('https://automation.bs4server.com/bs4webhook_chat.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body.toString(),
      });

      const data = await response.json();
      setMessages(data.messages.reverse());
      setSendDisabled(false);
      scrollToBottom();

    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const renderStartButton = () => {
    return (
      <Button  sx={{backgroundColor:colors.secondary.backgroundColor,padding:3,width:'60%',margin:'auto',fontSize:'1.6vh',borderRadius:8}} variant="contained" onClick={handleChatToggle}>
          Rozpocznij chat
      </Button>
    )
  }

  const renderMessages = () => {
    return (
      <>
        <MessageList 
          messages={messages} 
          colors={colors} 
          avatar={defaultAvatar} 
          callbackClickAction={()=>setIsPhoneModalOpen(true)} 
          buttonCallMe={configTexts.buttonCallMe} 
          buttonAskForHuman={configTexts.buttonAskForHuman} 
          showHumanButton={false} /> 
          {/* zmienić na isWorkTime */}
        <ChatInput
          userInput={userInput}
          onInputChange={setUserInput}
          onSendMessage={sendMessage}
          sendDisabled={sendDisabled}
          colors = {colors}
        />
      </>
    )
  }

  return (
    <Box sx={{ position: 'fixed', bottom: 20, right: 20 }}>
      <Paper
        elevation={6}
        sx={{
          width: 600,
          maxHeight: 700,
          minHeight: 600,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 4,
        }}
      >
        <ChatHeader
          colors={colors}
          onClose={() => setIsDialogOpen(true)}
        />

        {isListening && 
        <>
        <div className='loader'></div>
        <Typography sx={{textAlign:'center',fontSize:'1.6vh',padding:2}}>Czekaj na konsultanta...</Typography>

        </>}
        
        {(!isWorkTime && type==ASSISTANT_TYPE_NOAI) ? 
        (<OfflineScreen text={configTexts.greetOffline} buttonCallMe={configTexts.buttonCallMe} callbackClickAction={()=>setIsPhoneModalOpen(true)} colors={colors} />) : 
        (isChatRunning ? renderMessages() : renderStartButton())}
        
      </Paper>


      <ThankYouModal
        open={isThankYouModalOpen}
        onClose={() => setIsThankYouModalOpen(false)}
        onConfirm={() => {closeModal();setIsThankYouModalOpen(false);}}
        thankYouText={configTexts.greetAfterPhone}
      />

      <PhoneNumberModal
        open={isPhoneModalOpen}
        onClose={() => setIsPhoneModalOpen(false)}
        onConfirm={handlePhoneConfirm}
        label={configTexts.greetAskPhone}
      />

      <ConfirmDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={() => closeModal()}
      />

    </Box>
  );
};

export default Chat;